import * as React from 'react';

import { goToPartSmart, ifLoggedIn, partSmartUrl } from 'src/utils/navigation';
import './PartSmart.scss';
import partSmartIcon from 'src/assets/partSmart';
import i18n from 'src/translation/i18n';

interface IMyOrdersTrackingState {
  floatingIsOpen: boolean;
}

interface IMyOrdersTrackingProps {
  isLoggedIn: boolean;
}

export default class PartSmart extends React.Component<
  any,
  IMyOrdersTrackingState
> {
  private flyMenuRef: any = null;

  constructor(props: any) {
    super(props);

    this.state = {
      floatingIsOpen: false
    };
  }

  /* 
    openMenu
   */
  private openMenu = () => {
    this.setState({ floatingIsOpen: true });
  };

  /* 
    closeMenu
   */
  private closeMenu = () => {
    this.setState({ floatingIsOpen: false });
  };

  /* 
    handleMenuState
   */
  private handleMenuState = () => {
    this.state.floatingIsOpen ? this.closeMenu() : this.openMenu();
  };

  private handleClickOutside = (e: any) => {
    if (this.flyMenuRef == null || this.flyMenuRef.contains == null) {
      return;
    }
    if (this.flyMenuRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      floatingIsOpen: false
    });
  };

  public componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
  }

  private goToPartSmart = () => ifLoggedIn(() => goToPartSmart());

  public render() {
    const { t } = this.props;
    const menuState = this.state.floatingIsOpen ? 'opened' : '';

    return (
      <div
        className=""
        onClick={this.handleMenuState}
      >
        <div className="">
          <a
            href={partSmartUrl()}
            className="menu-item menu-link"
            target="_blank"
          >
            <div>
              <img
                src={partSmartIcon}
                alt="Part Smart"
                className='part-smart-link'
              />
            </div>
          </a>
        </div>
      </div>
    );
  }
}
